import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isClickable", "onClick", "id"];
import React, { memo, useCallback } from 'react';
export var withClickingWrapper = function withClickingWrapper(WrappedComponent) {
  return /*#__PURE__*/memo(function (_ref) {
    var _ref$isClickable = _ref.isClickable,
      isClickable = _ref$isClickable === void 0 ? false : _ref$isClickable,
      onClick = _ref.onClick,
      id = _ref.id,
      props = _objectWithoutProperties(_ref, _excluded);
    var handleClick = useCallback(function () {
      if (isClickable && onClick) {
        onClick(id);
      }
    }, [isClickable, onClick, id]);
    return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, props, {
      handleClick: handleClick,
      isClickable: isClickable,
      onClick: onClick,
      "data-t-id": "Step-hocs"
    }));
  });
};